import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const DataDeletion = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-pink-50">
      <Navbar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Hướng dẫn xóa dữ liệu</h1>
        <p className="text-gray-600 mb-8">Cập nhật lần cuối: Tháng 3 năm 2026</p>

        <div className="prose prose-pink max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Quyền xóa dữ liệu của bạn</h2>
            <p className="text-gray-600">
              Theo chính sách dữ liệu của Facebook và quy định bảo vệ dữ liệu cá nhân, bạn có quyền 
              yêu cầu xóa tất cả dữ liệu cá nhân mà An Nhi đã thu thập về bạn.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Dữ liệu sẽ bị xóa</h2>
            <div className="bg-pink-50 p-4 rounded-lg">
              <p className="text-gray-700 font-medium mb-2">Khi bạn yêu cầu xóa dữ liệu, chúng tôi sẽ xóa:</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Thông tin tài khoản (email, mật khẩu)</li>
                <li>Thông tin thai kỳ (tuần mang thai, ngày dự sinh)</li>
                <li>Hồ sơ y tế đã lưu trữ</li>
                <li>Lịch sử trò chuyện với trợ lý AI</li>
                <li>Lịch sử khám thai</li>
                <li>Facebook PSID và cài đặt thông báo</li>
                <li>Tất cả các tệp tin đã tải lên</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Cách yêu cầu xóa dữ liệu</h2>
            
            <div className="space-y-4">
              <div className="bg-blue-50 p-4 rounded-lg">
                <h3 className="text-lg font-medium text-blue-700 mb-2">Phương pháp 1: Xóa qua ứng dụng</h3>
                <ol className="list-decimal list-inside text-gray-600 space-y-1">
                  <li>Đăng nhập vào tài khoản An Nhi</li>
                  <li>Vào phần "Hồ sơ" (Profile)</li>
                  <li>Nhấn vào "Xóa tài khoản"</li>
                  <li>Xác nhận việc xóa</li>
                </ol>
              </div>

              <div className="bg-green-50 p-4 rounded-lg">
                <h3 className="text-lg font-medium text-green-700 mb-2">Phương pháp 2: Gửi email yêu cầu</h3>
                <p className="text-gray-600 mb-2">Gửi email đến:</p>
                <p className="text-gray-800 font-medium">caoanh0928@gmail.com</p>
                <p className="text-gray-600 mt-2">Với tiêu đề: "Yêu cầu xóa dữ liệu - [Email của bạn]"</p>
              </div>

              <div className="bg-yellow-50 p-4 rounded-lg">
                <h3 className="text-lg font-medium text-yellow-700 mb-2">Phương pháp 3: Qua Facebook</h3>
                <ol className="list-decimal list-inside text-gray-600 space-y-1">
                  <li>Vào Cài đặt Facebook</li>
                  <li>Chọn "Ứng dụng và trang web"</li>
                  <li>Tìm "An Nhi" và chọn "Gửi yêu cầu xóa dữ liệu"</li>
                  <li>Chúng tôi sẽ nhận được thông báo và xử lý</li>
                </ol>
              </div>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Thời gian xử lý</h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <ul className="text-gray-600 space-y-2">
                <li><strong>Ngay lập tức:</strong> Vô hiệu hóa tài khoản và ngừng gửi thông báo</li>
                <li><strong>Trong vòng 24 giờ:</strong> Xóa dữ liệu từ máy chủ ứng dụng</li>
                <li><strong>Trong vòng 7 ngày:</strong> Xóa dữ liệu từ hệ thống sao lưu</li>
                <li><strong>Trong vòng 30 ngày:</strong> Xóa hoàn toàn tất cả dữ liệu</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Xác nhận xóa dữ liệu</h2>
            <p className="text-gray-600">
              Sau khi xóa dữ liệu hoàn tất, chúng tôi sẽ gửi email xác nhận đến địa chỉ email 
              đã đăng ký (hoặc email bạn cung cấp trong yêu cầu).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Dữ liệu được giữ lại</h2>
            <p className="text-gray-600">
              Chúng tôi có thể giữ lại một số dữ liệu để:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2 mt-2">
              <li>Tuân thủ nghĩa vụ pháp lý</li>
              <li>Giải quyết tranh chấp</li>
              <li>Ngăn chặn gian lận</li>
            </ul>
            <p className="text-gray-600 mt-2">
              Những dữ liệu này sẽ được xóa sau khi hết hạn nghĩa vụ pháp lý.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Liên hệ</h2>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="text-gray-800"><strong>An Nhi - Data Protection Officer</strong></p>
              <p className="text-gray-600">Email: <a href="mailto:caoanh0928@gmail.com" className="text-blue-600 hover:underline">caoanh0928@gmail.com</a></p>
              <p className="text-gray-600">Website: <a href="https://annhi.site" className="text-blue-600 hover:underline">https://annhi.site</a></p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">URL xóa dữ liệu cho Facebook</h2>
            <p className="text-gray-600">
              Facebook Data Deletion Callback URL:
            </p>
            <div className="bg-gray-200 p-3 rounded mt-2 font-mono text-sm text-gray-800 break-all">
              https://annhi-backend.onrender.com/data-deletion
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DataDeletion;